/**
 * @preserve
 * jQuery Change Color - v1.0.0
 * Copyright (c) 2014 Karsten Müller
 */

/**
 * jQuery Plugin to toggle class of kontext when reaching specific croll position.
 *
 * Requires _jquery.scroll-toggle.js
 *
 * The target of the class toggle can defined other than the kontext itself by setting the option target to a jQuery object
 */

(function ( $ ){

	var defaults = {

		class: "toggled",
		offset: 0,
		target: -1

	}

	$.fn.toggleClass = function(options){

		if (typeof $.fn.scrollToggle !== "undefined"){

			var options = options || {};

			return this.each(function(){

				var kontext = $(this);


					/* Einstellungen über Data-Attribute */

				var data = {
					position: kontext.data("scroll-toggle-position"),
					offset: kontext.data("scroll-toggle-offset"),
					class: kontext.data("scroll-toggle-class")
				}


					/* Einstellungen vereinen */

				var settings = $.extend({}, defaults, options, data);

				if (settings.target === -1){
					settings.target = kontext;
				}

				new ToggleClass(kontext, settings);

			});

		} else {

			return this;

		}

	};

	var ToggleClass = function(kontext, settings){

		var self = this;

		this.kontext = kontext;
		this.settings = settings;

		kontext.scrollToggle({
			callbackIn: function(){
				self.toggle(true)
			},
			callbackOut: function(){
				self.toggle(false)
			}
		});

	}

	ToggleClass.prototype.toggle = function(toggle){

		if (toggle){
			this.settings.target.addClass("toggled-class-" + this.settings.class);
		} else {
			this.settings.target.removeClass("toggled-class-" + this.settings.class);
		}


			/* Letzte Klasse finden */

		var toggled_klassen = [];

		var klassen = this.settings.target.attr("class").split(/\s+/);

		for (var $i in klassen){

			var klasse = klassen[$i];

			if (klasse.match(/^toggled-class-.+?-latest/)){
				this.settings.target.removeClass(klasse);
			} else if (klasse.match(/^toggled-class-/)){
				toggled_klassen.push(klasse);
			}

		}

		if (toggled_klassen.length !== 0){
			this.settings.target.addClass(toggled_klassen[toggled_klassen.length - 1] + "-latest");
		}

	}

}( jQuery ));
